import * as React from 'react';
import { Composites, ToggleSwitch } from '@wix/wix-base-ui/lib/esm';
import type { IWbuToggleSwitchProps } from '../WbuToggleSwitch.props';
import WbuContainer from '../../WbuContainer/WbuContainer';
import './WbuToggleSwitch.global.scss';
import { getDataAttributes } from '../../../common/utils';

const WbuToggleSwitch: React.FC<IWbuToggleSwitchProps> = props => {
  const {
    id,
    className,
    label,
    toggleSwitch,
    disabled,
    isDisabled,
    divider,
    updateComponentPropsInViewer,
    onChange,
    onMouseEnter,
    onMouseLeave,
  } = props;

  const _onChange = (val: boolean) => {
    updateComponentPropsInViewer({ toggleSwitch: val });
    onChange?.({ type: 'change' } as React.ChangeEvent);
  };

  return (
    <WbuContainer
      id={id}
      {...getDataAttributes(props)}
      className={className}
      divider={divider}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Composites.ToggleSwitch>
        <ToggleSwitch
          label={label || 'Label'}
          value={toggleSwitch}
          disabled={isDisabled || disabled}
          onChange={_onChange}
        />
      </Composites.ToggleSwitch>
    </WbuContainer>
  );
};

export default WbuToggleSwitch;
